// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>31</span>&nbsp;&nbsp;When you hide your face they are troubled;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;when you take away their breath,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;they die and return again to the dust.<br> </p> </div></div>";
// Exports
module.exports = code;